import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useService } from 'hooks/useService';

const useHandleRedirects = ({searchState, type = 'online'}) => {
    const router = useRouter();
    const [{}, fireSearchCity] = useService();
    const _type = type === 'online' ? 'auctions' : 'live-auctions';

    const getCity = async search_term => {
        const data = await fireSearchCity({
            url: '/hooks/autocomplete/cities',
            params: {search_term},
        });

        return data?.cities || [];
    };

    const redirectToHomePage = () => {
        router.push(`/${_type}`,`/${_type}`, { shallow: true });
    };

    const handleCityPageRedirects = async ({_formatTermCity, _termCity}) => {
        const data = await getCity(_termCity);

        // May there be more than one city in the same state ex: Dallas, tx and Lake Dallas, tx
        if (data.length >= 1) {
            const _formatQueryCity = `${router.query.state}/${router.query.city}`;

            if (_formatTermCity !== _formatQueryCity) {
                router.push(
                    `/${_type}/[state]/[city]`,
                    `/${_type}/${_formatTermCity.toLowerCase()}`,
                    {shallow: true},
                );
            }
        } else {
            redirectToHomePage();
        }

    };

    useEffect(() => {
        const _termCity = searchState?.search_obj?.term_city;
        const _termState = searchState?.search_obj?.term_state;
        let _formatTermCity;

        if (_termCity) _formatTermCity =`${_termCity.split(', ')[1]}/${_termCity.split(', ')[0]}`;
        if (router.query.city) {
            if (searchState?.search_obj?.type === 'city' && _termCity) {
                handleCityPageRedirects({
                    _formatTermCity,
                    _termCity,
                });
            } else {
                router.push(`/${_type}`,`/${_type}`, { shallow: true });
            }
        } else if (router?.query?.state && !router?.query?.city) {
            if (_termState) {
                router.push(
                    `/${_type}/[state]`,
                    `/${_type}/` + _termState.toLowerCase(),
                    { shallow: true },
                );
            } else {
                redirectToHomePage();
            }
        } else {
            if (searchState?.search_obj?.type === 'city' && _termCity) {
                router.push(
                    `/${_type}/[state]/[city]`,
                    `/${_type}/${_formatTermCity.toLowerCase()}`,
                    { shallow: true },
                );
            }

            if (searchState?.search_obj?.type === 'state' && _termState) {
                router.push(
                    `/${_type}/[state]`,
                    `/${_type}/` + _termState.toLowerCase(),
                    { shallow: true },
                );
            }
        }
    }, [searchState.search_obj]);

    return null;
};

export default useHandleRedirects;